




















import { Component, Vue, Prop } from 'vue-property-decorator';
import ColorButton from '@/components/ColorButton.vue';

@Component({
  components: {
    ColorButton
  }
})
export default class Popup extends Vue {
  @Prop({ type: String, default: '' })
  title!: string;

  @Prop({ type: String, default: '' })
  text!: string;

  @Prop({ type: String, default: '' })
  buttonOK!: string;

  @Prop({ type: String, default: '' })
  buttonNG!: string;
}
